/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CalendarLockedIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Calendar Locked',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M35.161 24.048h-1.244v-1.477C33.917 17.837 30.372 14 26 14s-7.917 3.837-7.917 8.571v1.477h-1.291a.826.826 0 0 0-.792.857v10.238a.826.826 0 0 0 .792.857h18.369a.826.826 0 0 0 .791-.857V24.905a.825.825 0 0 0-.791-.857Zm-13.244-1.477c0-2.84 1.46-5.143 4.083-5.143s4.083 2.3 4.083 5.143v1.477h-8.166Zm5.666 8.762v1.81a.826.826 0 0 1-.791.857h-1.584a.826.826 0 0 1-.791-.857v-1.81a2.652 2.652 0 0 1-.792-1.9 2.382 2.382 0 1 1 4.75 0 2.652 2.652 0 0 1-.792 1.9Z"
    />
    <path
      d="M13.467 25a2.963 2.963 0 0 1 .179-1H4V6h4v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6h10v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6h4v5.74a9.822 9.822 0 0 1 2 1.292V5a1 1 0 0 0-1-1h-5V1a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3H12V1a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3H3a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h10.467Z"
    />
  </svg>`;
};
